import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//解决vue路由重复导航错误
//获取原型对象上的push函数
// let originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
//
// originalPush = VueRouter.replace;
// VueRouter.replace = function replace(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new VueRouter({
  mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Home.vue')
    },
    {
      path: '/query',
      name: 'query',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Query.vue')
    },
    {
      path: '/person',
      name: 'person',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Person.vue')
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Invitation.vue')
    },
    {
      path: '/invitationStep',
      name: 'invitationStep',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/InvitationStep.vue')
    },
    {
      path: '/invitationEnhanced',
      name: 'invitationEnhanced',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/InvitationEnhanced.vue')
    },
    {
      path: '/apc',
      name: 'apc',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Apc.vue')
    },
    {
      path: '/conference',
      name: 'conference',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Conference.vue')
    },
    {
      path: '/org_reg',
      name: 'org_reg',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/OrgReg.vue')
    },
    {
      path: '/org_list',
      name: 'org_list',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/OrgList')
    },
    {
      path: '/terms_use',
      name: 'terms_use',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/TermsUse')
    },
    {
      path: '/cookie',
      name: 'cookie',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Cookie')
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Privacy')
    },
    {
      path: '/_login',
      name: 'login',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Login.vue')
    },
    {
      path: '/:id([A-Za-z0-9\\-]+)',   // 只匹配由数字与横杠组成的路径，避免和其他路由冲突
      name: 'personById',
      meta: {
        hideHeader: false
      },
      component: () => import('@views/valurev/Person.vue')
    }
  ],
  // routes
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
